<template>
  <div class="flex items-center justify-center">
    <div class="waiting">
      <div class="waiting-circle"></div>
    </div>
  </div>
</template>

<style scoped>
.waiting {
  width: 72px;
  height: 72px;
  margin: 8px;
}

.waiting-circle {
  width: 64px;
  height: 64px;
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top-color: #2196f3;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>